import { isBoolean, startCase } from 'lodash/fp';
import { type SimpleEntity } from '@/types';

export const normalizeSimpleFormOptions = (
  options: (SimpleEntity & { boolean?: boolean })[],
  addEmptyOption = false,
) => {
  const normalizedOptions = options?.map(({ id, name, boolean }: any) => ({
    label: startCase(name),
    value: isBoolean(boolean) ? boolean : String(id),
  }));

  if (addEmptyOption) {
    normalizedOptions.unshift({ label: '—', value: '' });
  }

  return normalizedOptions;
};
